const STEPS = [
  {
    label: "Notice.",
    body: "Start by noticing what keeps tugging at you.",
    indent: "ml-0",
  },
  {
    label: "Get Honest.",
    body: "What do you want when nobody else gets a vote?",
    indent: "ml-6 sm:ml-10",
  },
  {
    label: "Follow One Clue.",
    body: "You don\u2019t need to know where it leads.",
    indent: "ml-12 sm:ml-20",
  },
  {
    label: "Try Something.",
    body: "Small enough that you don\u2019t need six months of courage first.",
    indent: "ml-16 sm:ml-28",
  },
  {
    label: "Pay Attention.",
    body: "Keep what feels true. Change what doesn\u2019t. Then do it again.",
    indent: "ml-20 sm:ml-36",
  },
];

export function TheProgression() {
  return (
    <section
      data-testid="believing-happy-progression-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-14 md:py-16 reveal">
        <h2
          data-testid="believing-happy-progression-headline"
          className="font-display text-[30px] sm:text-[38px] lg:text-[44px] leading-[1.16] tracking-tight text-[#1C1917] max-w-xl"
        >
          You don&rsquo;t need the whole blueprint.
        </h2>

        <div className="mt-8 space-y-5">
          {STEPS.map((step) => (
            <div
              key={step.label}
              className={`${step.indent} max-w-md sm:max-w-lg`}
            >
              <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-1">
                {step.label}
              </p>
              <p className="text-lg md:text-xl leading-relaxed text-[#57534E]">
                {step.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 ml-24 sm:ml-44 max-w-sm">
          <p
            data-testid="believing-happy-progression-closing-line"
            className="font-display italic text-2xl md:text-3xl leading-snug text-[#1C1917]"
          >
            Clarity rarely arrives all at once.
            <br />
            Usually, it shows up while you&rsquo;re moving.
          </p>
        </div>
      </div>
    </section>
  );
}
